import React from 'react';
import '../template-file-css/document-file-template.css';


export const ROC_ClientConfidentiality = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='ROC_ClientConfidentiality' className='file-pdf-document'>
            <div className='file-template'>


                <p className='w-750'> <center> Limits on Client Confidentiality </center> </p>

                <p className='w-750'>
                    We are required to disclose confidential information if any of the following conditions exist:
                    <ol>
                        <li> You are a danger to yourself or others.</li>
                        <li> You seek treatment to avoid detection or apprehension or enable anyone to commit a crime.</li>
                        <li> Your therapist was appointed by the courts to evaluate you.</li>
                        <li> Your contact with your therapist is for the purpose of determining your sanity in criminal proceedings.</li>
                        <li> Your contact is for the purpose of establishing your competence.</li>
                        <li> Your contact is one in which your psychotherapist must file a report to a public employer or as to disclose information required to be recorded in a public office, if such report is open to public inspection.</li>
                        <li> You are under the age of 16 years and are the victim of a crime.</li>
                        <li> You are a minor and your psychotherapist reasonably suspects you are the victim of child abuse.</li>
                        <li> You die and the communication is important to decide and issue concerning deed or conveyance, will or other writings executed involving you affecting as interest in property.</li>
                        <li> You file sui against your therapist for breech of duty or your therapist files suit against you.</li>
                        <li> You have filed suit against anyone and have claimed mental emotional damages as part of the suit. You waive your rights to privacy or give consent to limited disclosure by your therapist.</li>
                        <li> Your insurance company paying for services has the right to review all records.</li>
                    </ol>

                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp;
                        </td>
                        <td className='signature w-375'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Client Signature
                        </td>
                        <td className='small w-375'>Date
                        </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp;
                        </td>
                        <td className='signature w-375'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Staff Signature
                        </td>
                        <td className='small w-375'>Date
                        </td>
                    </tr>
                </table>




            </div>
        </form>

    )
}